import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  role: "list",
  class: "grid grid-cols-1 gap-4 lg:grid-cols-2"
}
const _hoisted_4 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_5 = { class: "flex-shrink-0 pl-4 pr-4 flex items-start justify-start" }
const _hoisted_6 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_7 = { class: "flex-shrink-0 pl-4 pr-4 flex items-start justify-start" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mt-4 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4" }
const _hoisted_10 = {
  key: 1,
  class: "pt-8"
}
const _hoisted_11 = {
  role: "list",
  class: "mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2"
}
const _hoisted_12 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_13 = { class: "flex-shrink-0 pl-4 pr-4 flex items-start justify-start" }
const _hoisted_14 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_15 = { class: "flex-shrink-0 pl-4 pr-4 flex items-start justify-start" }
const _hoisted_16 = { class: "text-base font-extralight mt-4 p-6 border border-solid rounded-xl border-black font-poppins" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]

import { ref, watch } from 'vue';
import VoipSelectorProduct from './VoipSelectorProduct.vue';
import { CheckCircleIcon } from '@heroicons/vue/outline';
import { CheckCircleIcon as CheckCircleSolidIcon } from '@heroicons/vue/solid';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VoipSelector',
  props: {
    products: {},
    isVoipAdded: { type: Boolean },
    isVoipListed: { type: Boolean },
    selected: {}
  },
  emits: ["onPlanSelected", "onVoipToggled", "onListingStatusToggled"],
  setup(__props: any, { emit: __emit }) {


const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const voipInformation = brandService.getVoipInformation();

const props = __props;

const emit = __emit;

// Start from the parent's state so a restored/loaded VoIP plan shows as "Yes".
const voipProductAdded = ref(props.isVoipAdded);
const voipListedNumber = ref(props.isVoipListed);
watch(() => props.isVoipAdded, (isVoipAdded) => {
  voipProductAdded.value = isVoipAdded;
});
watch(() => props.isVoipListed, (isVoipListed) => {
  voipListedNumber.value = isVoipListed;
});
const productSelected = ref<Product|null>();

const handleClickAddVoipProduct = () => {
  voipProductAdded.value = true;
  emit('onVoipToggled', true);
};

const handleClickRemoveVoipProduct = () => {
  voipProductAdded.value = false;
  emit('onVoipToggled', false);
};

const handleClickListedVoipProduct = () => {
  voipListedNumber.value = true;
  emit('onListingStatusToggled', true);
};

const handleClickUnlistedVoipProduct = () => {
  voipListedNumber.value = false;
  emit('onListingStatusToggled', false);
};

const handleSelectProduct = (product: Product): void => {
  productSelected.value = product;
  emit('onPlanSelected', product.id);
};

const isSelectedProduct = (product: Product): boolean => {
  return product.id === props.selected;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark", [ voipProductAdded.value ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]])
        }, [
          _createElementVNode("div", {
            onClick: handleClickAddVoipProduct,
            class: _normalizeClass(["transition duration-250 relative flex-1 flex items-center justify-between", [(voipProductAdded.value ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-2xl transition duration-250 text-black font-poppins-bold", [voipProductAdded.value ? 'text-white' : 'text-black']])
              }, "Yes", 2)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (!voipProductAdded.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["text-right mr-2 w-7 h-7 text-white rounded-full border border-solid", [ voipProductAdded.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                  }, null, 2))
                : _createCommentVNode("", true),
              (voipProductAdded.value)
                ? (_openBlock(), _createBlock(_unref(CheckCircleSolidIcon), {
                    key: 1,
                    class: "text-right pr-2 w-8 h-8 text-white",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark", [ !voipProductAdded.value ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]])
        }, [
          _createElementVNode("div", {
            onClick: handleClickRemoveVoipProduct,
            class: _normalizeClass(["transition duration-250", [(!voipProductAdded.value ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between rounded-2xl truncate')]])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-2xl transition duration-250 text-black font-poppins-bold", [ !voipProductAdded.value ? 'text-white' : 'text-black' ]])
              }, "No", 2)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (voipProductAdded.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["text-right mr-2 w-7 h-7 text-white rounded-full border border-solid", [ !voipProductAdded.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                  }, null, 2))
                : _createCommentVNode("", true),
              (!voipProductAdded.value)
                ? (_openBlock(), _createBlock(_unref(CheckCircleSolidIcon), {
                    key: 1,
                    class: "text-right pr-2 w-8 h-8 text-white",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 2)
      ]),
      (voipProductAdded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return (_openBlock(), _createBlock(VoipSelectorProduct, {
                  onHandleSelectProduct: handleSelectProduct,
                  product: product,
                  key: product.name,
                  isSelectedProduct: isSelectedProduct(product)
                }, null, 8, ["product", "isSelectedProduct"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (voipProductAdded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-lg text-black font-poppins tracking-normal pt-2 py-0 my-0 font-normal" }, "Voip Home Number Listed Or Listed?", -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark", [ voipListedNumber.value ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]])
              }, [
                _createElementVNode("div", {
                  onClick: handleClickListedVoipProduct,
                  class: _normalizeClass(["transition duration-250 relative flex-1 flex items-center justify-between", [(voipListedNumber.value ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]])
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-2xl transition duration-250 text-black font-poppins-bold", [voipListedNumber.value ? 'text-white' : 'text-black']])
                    }, "Listed", 2)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (!voipListedNumber.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: _normalizeClass(["text-right mr-2 w-7 h-7 text-white rounded-full border border-solid", [ voipListedNumber.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                        }, null, 2))
                      : _createCommentVNode("", true),
                    (voipListedNumber.value)
                      ? (_openBlock(), _createBlock(_unref(CheckCircleSolidIcon), {
                          key: 1,
                          class: "text-right pr-2 w-8 h-8 text-white",
                          "aria-hidden": "true"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark", [ !voipListedNumber.value ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]])
              }, [
                _createElementVNode("div", {
                  onClick: handleClickUnlistedVoipProduct,
                  class: _normalizeClass(["transition duration-250 relative flex-1 flex items-center justify-between", [(!voipListedNumber.value ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-2xl transition duration-250 text-black font-poppins-bold", [!voipListedNumber.value ? 'text-white' : 'text-black']])
                    }, "Unlisted", 2)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (voipListedNumber.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: _normalizeClass(["text-right mr-2 w-7 h-7 text-white rounded-full border border-solid", [ !voipListedNumber.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                        }, null, 2))
                      : _createCommentVNode("", true),
                    (!voipListedNumber.value)
                      ? (_openBlock(), _createBlock(_unref(CheckCircleSolidIcon), {
                          key: 1,
                          class: "text-right pr-2 w-8 h-8 text-white",
                          "aria-hidden": "true"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ], 2)
            ]),
            _createElementVNode("p", _hoisted_16, [
              _cache[0] || (_cache[0] = _createTextVNode(" Your number will be set as unlisted by default but will be registered in the IPND database for emergency services. This can be changed at any time by contacting our friendly Australian-based support team on ")),
              _createElementVNode("a", {
                class: "text-black font-bold hover:text-blue-800 hover:underline transition duration-250",
                target: "_blank",
                href: 'mailto:' + _unref(voipInformation).email
              }, _toDisplayString(_unref(voipInformation).email), 9, _hoisted_17),
              _cache[1] || (_cache[1] = _createTextVNode(" or ")),
              _createElementVNode("a", {
                class: "text-black font-bold hover:text-blue-800 hover:underline transition duration-250",
                target: "_blank",
                href: 'tel:' + _unref(voipInformation).phone
              }, _toDisplayString(_unref(voipInformation).phone), 9, _hoisted_18),
              _cache[2] || (_cache[2] = _createTextVNode(". More information on IPND Policy can be found ")),
              _createElementVNode("a", {
                href: _unref(voipInformation).csaAgreementUrl,
                target: "_blank",
                class: "text-black font-bold hover:text-blue-800 hover:underline transition duration-250"
              }, "here.", 8, _hoisted_19)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})